// @flow
import * as React from 'react';

type Props = {
  defaultValue: boolean,
  children: (boolean, Function) => React.Node
};

type State = {
  toggled: boolean
};

export default class ToggleHelperContainer extends React.Component<
  Props,
  State
> {
  static defaultProps = {
    // eslint-disable-next-line react/default-props-match-prop-types
    defaultValue: false
  };

  state = {
    toggled: this.props.defaultValue
  };

  render() {
    // eslint-disable-next-line react/prop-types
    return this.props.children(this.state.toggled, setToggle =>
      this.setState(prevState => {
        const toggled =
          typeof setToggle === 'boolean' ? setToggle : !prevState.toggled;
        return { toggled };
      })
    );
  }
}
